import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants";

export const recipientOptions = [
    // { value: "users", id: "users", name: "All users" },
    { value: "patient", id: "patient", name: "Patient" },
    { value: "relatedperson", id: "relatedperson", name: "Related person" },
    { value: "practitioner", id: "practitioner", name: "Practitioner" },
];
export const deliveryOptions = [
    { value: "email", id: "email", name: "Email" },
    { value: "push_notification", id: "push_notification", name: "Push Notification" },
    { value: "sms", id: "sms", name: "SMS" },
];

export const notificationTypeOptions = [
    { value: "default", name: "Default notification" },
    { value: "custom", name: "Custom notification" },
];

export const FormikObj = {
    initialValues: {
        type: "custom",
        orgId: "",
        eventId: "",
        recipients: [],
        deliveryMechanisms: [],
        customGroupId : [],
        title: "",
        content: "",
        emailSubject: "",
        emailContent: "",
    },
    validationSchema: Yup.object({
        type: conditionalValidation(
            Yup.string()
            .required("Required Notification type field")
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                label: "Notification Type",
                mandatory: true
            }),
        orgId: conditionalValidation(
            Yup.string().when(["type"], (type, schema) =>
            type === "custom"
                ? schema.required("Required Organization field")
                : schema),
                {
                    validation,
                    label: "Organization",
                }),
        recipients: Yup.array().min(1)
            .required("Required Recipants field"),
        eventId: conditionalValidation(
                Yup.string()
                .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
                {
                    label: "Event",
                    mandatory: true,
                    validation
                }),
        deliveryMechanisms: Yup.array().min(1)
            .required("Required Delivery Mechanisms field"),
        title: conditionalValidation(
                Yup.string()
                .max(50, "Must be 50 characters or less")
                .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
                {
                    validation,
                    mandatory: true,
                    label: "Notification Title"
                }),
        content: conditionalValidation(
            Yup.string().when(["deliveryMechanisms"], (deliveryMechanisms, schema) =>
            deliveryMechanisms.includes("push_notification") || deliveryMechanisms.includes("sms")
                ? schema.required("Required content field").matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
                : schema),
                {
                    validation,
                    label: "Content field"
                }),
        emailSubject: conditionalValidation(
                Yup.string().when(["deliveryMechanisms"], (deliveryMechanisms, schema) =>
                deliveryMechanisms.includes("email")
                    ? schema.required("Required email subject field")
                    : schema),
                    {
                        validation,
                        label: "Email Subject"
                    }),
        emailContent: conditionalValidation(
                Yup.string().when(["deliveryMechanisms"], (deliveryMechanisms, schema) =>
                deliveryMechanisms.includes("email")
                    ? schema.required("Required email content field")
                    : schema),
                    {
                        validation,
                        label: "Email Content"
                    }),
    }),
};
